import React, { useEffect, useState } from "react";
import { Container, Col, Row, Card } from "react-bootstrap";
import axios, { Axios } from "axios";
import LoadingIcon from "../../actions/LoadingIcon";
import uniqid from "uniqid";
import ShowSubjectsFromEmployer from "./ShowSubjectsFromEmployer";
import ShowSubjectsFromCoach from "./ShowSubjectsFromCoach";
import ChallengeOverview from "./ChallengeOverview";
import AdminPage from "../../adminSection/AdminPage";
import HomePageCoach from "../../mainSection/homeSection/HomePageCoach";
import { useHistory } from "react-router-dom";
import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuperAdminPage from "../../adminSection/SuperAdminPage";
import CustomButton from "../../buttons/customButton";

function HomePageUser() {
  const [responseNaam, setResponseNaam] = useState("");
  const userId = sessionStorage.getItem("Id");
  const [organisationLoading, setOrganisationLoading] = useState(true);
  const [roleNaam, setRoleNaam] = useState("");
  const token = sessionStorage.getItem("complexToken");
  const organisationId = sessionStorage.getItem("OrganisationId");
  const [activeTab, setActiveTab] = useState("trajecten");
  const [inviteEmail, setInviteEmail] = useState("");
  const [inviteLoading, setInviteLoading] = useState(false);
  const [inviteMessage, setInviteMessage] = useState(null);

  const data = {
    id: userId,
  };

  // krijg de data van de ingelogde user
  const getData = () => {
    axios
      .get(`/Users/${data.id}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        res.data.userRoles.map((result) => setRoleNaam(result.role.name));
        if (res.data.description !== null) sessionStorage.setItem("Description", res.data.description);
        if (res.data.organisation === null) {
          setResponseNaam("Er is nog geen organisatie aangeduid");
        } else {
          setResponseNaam(res.data.organisation.organisationName);
        }
      })
      .catch((err) => {
        console.log(err);
      });
      setOrganisationLoading(false);
    }
      
  useEffect(() => {
    getData();

    // API TESTING
    // axios
    // .get(`/Challenges/Employer/3`, {
    //   headers: { Authorization: `Bearer ${token}` },
    // })
    // .then((res) => console.log(res.data))
    // .catch((err) => console.log(err));
  }, []);

  const history = useHistory();
  function goToOPO() {
    history.push("/ChooseSubject");
  }

  const sendInvite = async (e) => {
    e.preventDefault();
    if (!inviteEmail) return;
    setInviteLoading(true);
    setInviteMessage(null);
    try {
      await axios.post(
        "/Invites",
        { email: inviteEmail, organisationId: parseInt(organisationId) },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setInviteMessage({ type: "success", text: `Uitnodiging verstuurd naar ${inviteEmail}.` });
      setInviteEmail("");
    } catch {
      setInviteMessage({ type: "danger", text: "Versturen mislukt. Controleer het e-mailadres en probeer opnieuw." });
    }
    setInviteLoading(false);
  };

  return (
    <div>
      { roleNaam === "SuperAdmin" ? (
        <div>
          <SuperAdminPage />
        </div>
      ) : roleNaam === "Admin" ? (
        <div>
          <AdminPage />
        </div>
      ) : roleNaam === "Coach" ? (
        <div>
          <HomePageCoach />
        </div>

      ) : roleNaam === "Employer" ? (

        <div>
          {organisationLoading ? (
            <div style={{ marginTop: "40vh" }}><LoadingIcon /></div>
          ) : (
            <Container lg={6} sm={12} style={{ marginTop: "3vh" }}>
              <Row style={{ marginBottom: "1rem" }}>
                <Col>
                  <h5 className="tekstNaamInstelling">{responseNaam}</h5>
                </Col>
              </Row>

              {/* Tabs */}
              <Row style={{ marginBottom: "1.5rem" }}>
                <Col>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    {["trajecten", "resultaten", "medewerkers"].map((tab) => (
                      <button
                        key={tab}
                        onClick={() => setActiveTab(tab)}
                        style={{
                          padding: "0.5rem 1.25rem",
                          borderRadius: "6px",
                          border: "2px solid #2d5971",
                          backgroundColor: activeTab === tab ? "#2d5971" : "white",
                          color: activeTab === tab ? "white" : "#2d5971",
                          fontWeight: activeTab === tab ? "700" : "400",
                          cursor: "pointer",
                          fontSize: "0.95rem",
                          textTransform: "capitalize",
                        }}
                      >
                        {tab === "trajecten" ? "Trajecten" : tab === "resultaten" ? "Resultaten & Mood" : "Medewerkers"}
                      </button>
                    ))}
                  </div>
                </Col>
              </Row>

              {/* Tab: Trajecten */}
              {activeTab === "trajecten" && (
                <>
                  {sessionStorage.getItem("LockedOut") !== "true" && (
                    <Row style={{ marginBottom: "1.5rem" }}>
                      <Col lg={6} sm={12}>
                        <button
                          onClick={goToOPO}
                          style={{
                            backgroundColor: "#2d5971",
                            color: "white",
                            borderRadius: "5px",
                            border: "none",
                            width: "100%",
                            padding: "0.5em 2em",
                            fontSize: "1.1rem",
                            cursor: "pointer",
                          }}
                        >
                          <FontAwesomeIcon icon={faPlusSquare} style={{ marginRight: "0.5rem" }} />
                          Onderwerp toevoegen
                        </button>
                      </Col>
                    </Row>
                  )}
                  <ShowSubjectsFromEmployer />
                  <ChallengeOverview />
                </>
              )}

              {/* Tab: Resultaten & Mood */}
              {activeTab === "resultaten" && (
                <ShowSubjectsFromCoach />
              )}

              {/* Tab: Medewerkers */}
              {activeTab === "medewerkers" && (
                <Row>
                  <Col lg={8} sm={12}>
                    <p style={{ color: "#555", marginBottom: "1rem" }}>
                      Stuur een uitnodiging naar een medewerker. Die ontvangt een e-mail met een link om zich te registreren op de app.
                    </p>
                    <form onSubmit={sendInvite} style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap" }}>
                      <input
                        type="email"
                        placeholder="E-mailadres medewerker"
                        value={inviteEmail}
                        onChange={(e) => setInviteEmail(e.target.value)}
                        required
                        style={{
                          flex: 1,
                          minWidth: "220px",
                          padding: "0.5rem 0.75rem",
                          borderRadius: "5px",
                          border: "1px solid #ced4da",
                          fontSize: "1rem",
                        }}
                      />
                      <button
                        type="submit"
                        disabled={inviteLoading}
                        style={{
                          backgroundColor: "#2d5971",
                          color: "white",
                          borderRadius: "5px",
                          border: "none",
                          padding: "0.5rem 1.5rem",
                          fontSize: "1rem",
                          cursor: inviteLoading ? "not-allowed" : "pointer",
                          opacity: inviteLoading ? 0.7 : 1,
                        }}
                      >
                        {inviteLoading ? "Versturen..." : "Uitnodiging versturen"}
                      </button>
                    </form>
                    {inviteMessage && (
                      <div style={{
                        marginTop: "0.75rem",
                        padding: "0.5rem 0.75rem",
                        borderRadius: "4px",
                        backgroundColor: inviteMessage.type === "success" ? "#d4edda" : "#f8d7da",
                        color: inviteMessage.type === "success" ? "#155724" : "#721c24",
                        fontSize: "0.9rem",
                      }}>
                        {inviteMessage.text}
                      </div>
                    )}
                  </Col>
                </Row>
              )}

            </Container>
          )}
        </div>
      ) : ( <><LoadingIcon/></>
      )}
    </div>
  );
}

export default HomePageUser;
